var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"topfixed-wrap"},[_c('div',{staticClass:"outer-width clearfix"},[_c('span',{staticClass:"icon-logoquan lf"}),_vm._v(" "),_c('a',{attrs:{"href":"tel:4008396360"}},[_c('span',{staticClass:"rf tel-zixun"},[_vm._v("咨询热线：400-839-6360")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f09ebe0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/topfixed.vue
// module id = null
// module chunks = 